import { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { FrameExtranet, PaginaSecao } from '@componentes-mu/componentes-mu'

import { useAuth } from '../../contexts/AuthContext'
import { useUserDetails } from '../../services/users/useUser'
import { LoadingOverlay } from '../Loading'
import { useUserStore } from '../../store/user'
import { useTicketFiltersStore } from '../../store/ticketFilters'


const tabRoutes = ['home', 'portal-conhecimento', 'cadastrar-ticket', 'tickets',
  'versoes-liberadas', 'treinamentos-recebidos', 'mapa-utilizacao'];

const tabTitles = [
  'Área do Cliente', 'Portal do Conhecimento', 'Cadastrar Ticket', 'Meus Tickets',
  'Versões Liberadas', 'Treinamentos Recebidos', 'Mapa de Utilização',
];


export const Layout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { logout, oidCliente } = useAuth()

  const [activeTab, setActiveTab] = useState<number>(0)
  const { clearFilters } = useTicketFiltersStore();

  const { data, isLoading } = useUserDetails(oidCliente, {
    enabled: !!oidCliente
  })

  useEffect(() => {
    if (data) {
      useUserStore.getState().setUser(data)
    }
  }, [data])

  useEffect(() => {
    const currentPath = location.pathname.split('/')[1]
    const tabIndex = tabRoutes.indexOf(currentPath)
    if (tabIndex !== -1) {
      setActiveTab(tabIndex)
    }
  }, [location.pathname])


  const onLogout = () => {
    useUserStore.getState().clearUser()
    clearFilters()
    logout()
    navigate('/')
  }

  const onTabChange = (section: PaginaSecao) => {
    const tab = tabRoutes[section.index];
    setActiveTab(section.index);
    navigate(`/${tab}`)
  }

  return (
    <>
      {isLoading && <LoadingOverlay />}
      {data && <FrameExtranet
        conteudoNotificacao={2}
        informacoesUsuario={{
          imagemEmpresa: '',
          empresa: data.nomeCliente,
          login: data.isMaster ? 'Usuário master' : 'Usuário Comum',
        }}
        notificacaoProps={{
          estado: 'success',
          tipo: "texto",
          conteudoNotificacao: ''
        }}
        onClickNotificacao={() => { }}
        onClickSecao={onTabChange}
        paginaAtual={activeTab}
        possuiIframe={activeTab === 1}
        onLogout={onLogout}
        tituloCabecalho={tabTitles[activeTab]}
      >
        <Outlet context={{ setActiveTab }} />
      </FrameExtranet>
      }
    </>
  )
}
